/** Angular */
import { Subject } from 'rxjs';
import { OnDestroy, Directive } from '@angular/core';

/**
 * This subscription destroyer class use the OnDestroy interface `lifecycle hook`, invoked immediately
 * after an instance is destroyed.
 * Constructors for derived classes must contain a `super()` call.
 * When you extend this class, your constructor: Must call super()
 */
@Directive()
export class DsSubscriptionDestroyer implements OnDestroy {
  /**
   * Subject triggered when the component is destroyed
   */
  destroy$: Subject<boolean> = new Subject<boolean>();

  /**
   * Clean up Subscription, when the instance is destroyed..
   */
  ngOnDestroy() {
    /** Cancel Observable executions */
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
